import SettingsPartContainer from "@baseUI/component/settings/SettingsPartContainer";
import ButtonDrawComponent from "@baseUI/component/button/ButtonDrawComponent";
import UIFacade from "@baseUI/UIFacade";
import Facade from "@baseUI/UIFacade";
import Signals from "@baseUI/controllers/UISignals";
import UICreatorComponent from "@baseUI/utils/UICreatorComponent";
import UICreatorText from "@baseUI/utils/UICreatorText";
import UICreatorGraphics from "@baseUI/utils/UICreatorGraphics";

export default class BetsSettingsPartContainer extends SettingsPartContainer {

    constructor(params) {
        super()
        this.setParametersSizePosition(params)
        this.init()
    }

    setParametersSizePosition(params){
        this.param = {
            panelPopupPosition: {x: 0, y: 0},
            betsCaptionPosition: [500, 0],
            lineCaption: {x1: -100, y1: 100, x2: 1300, y2: -100 },
            countRow: 4,
            settingsBtn: {width: 220, height: 130, spaceX: 40, spaceY: 50, startX: 100, startY: 230},
        }
    }

    init() {
        const panelPopup = UICreatorComponent.addContainer(this, this.param.panelPopupPosition)
        UICreatorText.addElementTextName('popupBetsCaption_TEXT', panelPopup, this.param.betsCaptionPosition)
        const line = this.param.lineCaption
        UICreatorGraphics.addLine(panelPopup, line.x1, line.y1, line.x2, line.y2)

        const betsValues = UIFacade.model.betsValues
        this.createPartBets(betsValues, panelPopup, this.param.countRow)
    }

    createPartBets(betsValues, panelPopup, countRow) {
        const settingsBtn = this.param.settingsBtn

        const panelBets = UICreatorComponent.addContainer(panelPopup, {x: settingsBtn.startX, y: settingsBtn.startY})
        panelPopup.addChild(panelBets)

        this.betsButtons = betsValues.map((element, index) => {
            const numberBtn = new ButtonDrawComponent(settingsBtn)
            panelBets.addChild(numberBtn)
            numberBtn.x = (settingsBtn.width + settingsBtn.spaceX) * (index % countRow)
            numberBtn.y = (settingsBtn.height + settingsBtn.spaceY) * Math.floor(index / countRow)
            const textBtn = Facade.model.setPossibleBets[index].toLowerCase()
                .replace(Facade.model.currency.toLowerCase(), '')

            numberBtn.addText(textBtn, 'systemTextButton')
            numberBtn.on('tapButton', () => {
                this.betsButtons.forEach(btn => {
                    if (btn !== numberBtn) {
                        btn.reset();
                    }
                })
                //TODO : push it to Model
                UIFacade.model.currentBetIndex = index//element
                Signals.setBet.dispatch(Facade.model.setPossibleBets[Facade.model.currentBetIndex])
                console.log('currentBetIndex  ', UIFacade.model.currentBetIndex)
                //  document.dispatchEvent(new CustomEvent('tap', {detail: {name: 'bet'}}))
            })
            return numberBtn;
        })
    }
}
